import { AppLayout } from '@/components/layout/AppLayout'
import { AtlasPage } from '@/components/ui/AtlasPage'
import { PageTitle } from '@/components/ui/PageTitle'
import { Separator } from '@/components/ui/Separator'
import { PageNumber } from '@/components/ui/PageNumber'
import { Button } from '@/components/ui/Button'
import { Link } from '@inertiajs/react'
import { SUPPLY_CATEGORY_ICONS, EnumIcon } from '@/lib/icons'

interface Photo {
  id: number
  url: string
  thumbnail_url: string
}

interface Supply {
  id: number
  name: string
  description: string | null
  category: string
  category_pl: string
  photo: Photo | null
}

interface Props {
  supplies: Supply[]
}


function SuppliesIndex({ supplies }: Props) {
  return (
    <AtlasPage>
      <PageTitle title="Zapasy" subtitle="Materiały i przyrządy" />
      <Separator />

      {supplies.length > 0 ? (
        <div className="grid grid-cols-1 gap-md sm:grid-cols-2 lg:grid-cols-3">
          {supplies.map((supply) => (
            <Link
              key={supply.id}
              href={`/supplies/${supply.id}`}
              className="group block border border-frame/30 bg-paper-dark/50 p-sm transition-shadow hover:shadow-hover"
            >
              {supply.photo ? (
                <img
                  src={supply.photo.thumbnail_url}
                  alt={supply.name}
                  className="mb-sm h-36 w-full object-cover"
                />
              ) : (
                <div className="mb-sm flex h-36 w-full items-center justify-center bg-desk/50">
                  <EnumIcon entry={SUPPLY_CATEGORY_ICONS[supply.category]} size={36} className="text-frame/40" />
                </div>
              )}
              <h3 className="font-display text-sm uppercase tracking-wider text-ink group-hover:text-botanical">
                {supply.name}
              </h3>
              <p className="text-xs text-frame mt-xs">{supply.category_pl}</p>
              {supply.description && (
                <p className="text-xs text-ink-light mt-xs font-label line-clamp-2">
                  {supply.description}
                </p>
              )}
            </Link>
          ))}
        </div>
      ) : (
        <div className="text-center py-xl">
          <p className="text-frame italic font-label">Brak zapasów w kolekcji.</p>
        </div>
      )}

      <Separator />
      <div className="flex justify-center">
        <Button href="/supplies/new">Dodaj zapas</Button>
      </div>

      <PageNumber number={10} />
    </AtlasPage>
  )
}

SuppliesIndex.layout = (page: React.ReactNode) => <AppLayout>{page}</AppLayout>
export default SuppliesIndex
